import React, { forwardRef, useState } from "react";
import {CalenderIcon} from "../../../../icons";

type CustomInputProps = {
    value?: string;
    onClick?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const formatDate = (input: string) => {
    const digitsOnly = input.replace(/\D/g, "");
    let result = "";

    if (digitsOnly.length <= 2) {
        result = digitsOnly;
    } else if (digitsOnly.length <= 4) {
        result = `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
    } else {
        result = `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4, 8)}`;
    }

    return result;
};

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value = "", onClick, onChange }, ref) => {
        const [inputValue, setInputValue] = useState(value);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const formatted = formatDate(e.target.value);
            setInputValue(formatted);

            // Giả lập onChange của react-datepicker
            if (onChange) {
                const fakeEvent = {
                    ...e,
                    target: { ...e.target, value: formatted },
                };
                onChange(fakeEvent as any);
            }
        };

        return (
            <div className="relative w-full">
                <input
                    ref={ref}
                    value={value || inputValue}
                    onClick={onClick}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded px-4 py-2.5 bg-white"
                    placeholder="dd/mm/yyyy"
                    inputMode="numeric"
                />
                <span className="absolute text-gray-500 -translate-y-1/2 pointer-events-none right-3 top-1/2 pr-2">
                    <CalenderIcon />
                </span>
            </div>
        );
    }
);

export default CustomInput;
